<template>
  <div class="page-content">
    <div class="search-wrap">
      <div class="search-options-wrap">
        <div class="option-item">
          <div class="option-title">{{ $t('public.status') }}</div>
          <a-select
            allowClear
            showSearch
            v-model="academic"
            style="width: 100%"
            :placeholder="$t('public.academicYear')"
            :dropdownMatchSelectWidth="false"
          >
            <a-select-option
              v-for="(item, index) in academicYearList"
              :key="index"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </div>

        <!-- <div class="search-wrap--input">
          <a-input-search
            :placeholder="
              $t('public.searchList', {
                content:
                  $t('public.submitter_lower') +
                  '、' +
                  $t('public.student_lower') +
                  ' ' +
                  $t('public.name_lower'),
              })
            "
            enterButton
            class="search-input"
            v-model="searchModel"
            @search="approvalData"
          />
        </div> -->
      </div>
      <div class="search-handles-wrap">
        <a-button type="primary" class="margin--right" @click="btnapprove">
          {{ $t('public.approve') }}
        </a-button>
        <a-button type="danger" class="margin--right" @click="btnReject">
          {{ $t('public.reject') }}
        </a-button>
        <a-button type="primary" @click="btnapproveAll">
          {{ $t('public.approveAll') }}
        </a-button>
      </div>
    </div>
    <a-table
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: selectChange,
      }"
      :data-source="approvalList"
      :rowKey="(approvalList) => approvalList.id"
      :scroll="{ x: 1500 }"
      :loading="loading"
      :pagination="{
        total: total,
        pageSize: pageSize,
        current: current,
        showTotal: (total) =>
          $t('public.page', { total: total, pageSize: pageSize }),
        onChange: currentChange,
      }"
    >
      <a-table-column
        :width="150"
        fixed="left"
        :title="$t('public.subject')"
        dataIndex="courseName"
      >
      </a-table-column>
      <a-table-column
        fixed="left"
        :width="150"
        :title="$t('public.student') + ' ' + $t('public.name_lower')"
        dataIndex="studentName"
      >
      </a-table-column>
      <a-table-column
        :width="150"
        :title="$t('report.academicYear')"
        dataIndex="academic"
      >
      </a-table-column>
      <a-table-column
        :width="150"
        :title="$t('public.semester')"
        dataIndex="semester"
      >
      </a-table-column>

      <!-- <a-table-column
          :width="150"
          :title="$t('public.teacher') + $t('public.name')"
          dataIndex="teacherName"
        >
        </a-table-column> -->
      <a-table-column
        :width="150"
        :title="$t('public.submitter')"
        dataIndex="submitterName"
      >
      </a-table-column>
      <!-- <a-table-column
        :width="150"
        :title="$t('public.approver')"
        dataIndex="approverName"
      >
      </a-table-column> -->
      <a-table-column
        :width="150"
        :title="$t('public.scoreType')"
        dataIndex="type"
      >
        <template slot-scope="type">
          <p>
            {{
              type == 1 ? 'Regular Grade' : type == 2 ? 'Semester Exam' : 'Quiz'
            }}
          </p>
        </template>
      </a-table-column>

      <!-- <a-table-column
        :width="150"
        :title="$t('public.approvalTime')"
        dataIndex="updateTime"
      >
      </a-table-column> -->

      <a-table-column
        :width="150"
        :title="$t('public.details')"
        dataIndex="details"
      >
      </a-table-column>
      <!-- //323 -->
      <a-table-column
        :width="150"
        :title="$t('public.submissionTime')"
        dataIndex="createTime"
      >
      </a-table-column>
      <a-table-column
        :width="150"
        fixed="right"
        :title="$t('public.oldScore')"
        dataIndex="oldScore"
      >
      </a-table-column>
      <a-table-column
        fixed="right"
        :width="150"
        :title="$t('public.newScore')"
        dataIndex="newScore"
      >
      </a-table-column>

      <a-table-column
        :width="150"
        fixed="right"
        :title="$t('public.operate')"
        dataIndex="id"
      >
        <template slot-scope="id, approvalList">
          <a
            style="margin-right: 15px; font-size: 14px"
            @click="() => btnapproveOne(approvalList.id)"
            >{{ $t('public.approve') }}</a
          >
          <a
            style="font-size: 14px; color: red"
            @click="() => btnRejectOne(approvalList.id)"
            >{{ $t('public.reject') }}</a
          >
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      academic: undefined,
      searchModel: '',

      selectedRowKeys: [],
      pageSize: 10,
      total: 0,
      current: 1,
      loading: false,
      approvalList: [],
    }
  },
  watch: {
    academic() {
      this.approvalData()
    },
  },
  methods: {
    selectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    currentChange(pageNumber) {
      this.current = pageNumber
      this.approvalData()
    },
    approvalData() {
      this.loading = true
      this.$http(this.$api.APPROVALDATAAPI, {
        academic: this.academic ? this.academic : '',
        userName: this.searchModel,
        pageSize: this.pageSize,
        pageNO: this.current,
        userId: this.userId,
      }).then((r) => {
        this.loading = false
        if (r.data.total > 0) {
          this.total = r.data.total
        }
        // this.total = r.data.total
        this.approvalList = r.data.rows
      })
    },
    btnapprove() {
      if (this.selectedRowKeys.length == 0) {
        return false
      }
      let data = {
        id: JSON.stringify(this.selectedRowKeys),
      }
      this.operationTips(
        this.$t('public.approve'),
        this.$t('public.approveTips') + this.$t('public.approve'),
        this.approveAdopt(data)
      )
    },
    btnReject() {
      if (this.selectedRowKeys.length == 0) {
        return false
      }
      let data = {
        id: JSON.stringify(this.selectedRowKeys),
      }
      this.operationTips(
        this.$t('public.reject'),
        this.$t('public.approveTips') + this.$t('public.reject'),
        this.approveReject(data)
      )
    },
    //同意得点击
    btnapproveOne(id) {
      let data = [id]
      this.operationTips(
        this.$t('public.approve'),
        this.$t('public.approveTips') + this.$t('public.approve'),
        this.approveAdopt({
          id: JSON.stringify(data),
        })
      )
    },
    //拒绝得点击
    btnRejectOne(id) {
      let data = [id]
      this.operationTips(
        this.$t('public.reject'),
        this.$t('public.approveTips') + this.$t('public.reject'),
        this.approveReject({
          id: JSON.stringify(data),
        })
      )
    },
    //全部同意
    btnapproveAll() {
      if (this.approvalList == null) return false
      this.operationTips(
        this.$t('public.approveAll'),
        this.$t('public.approveTips') + this.$t('public.approveAll'),
        this.approveAllAdopt()
      )
    },
    //审批同意
    approveAdopt(approveData) {
      return () => {
        this.$http(this.$api.APPROVALADOPT, approveData).then((r) => {
          if (r.code == 0) {
            this.selectedRowKeys = []
            this.$emit('read')
            this.approvalData()
            this.$notification.open({
              type: 'success',
              message: this.$t('public.approval'),
              description:
                this.$t('public.approval') + this.$t('class.success'),
            })
          }
        })
      }
    },
    //全部审批同意
    approveAllAdopt() {
      return () => {
        this.$http(this.$api.APPROVALALLADOPT).then((r) => {
          if (r.code == 0) {
            this.selectedRowKeys = []
            this.$emit('read')
            this.approvalData()
            this.$notification.open({
              type: 'success',
              message: this.$t('public.approval'),
              description:
                this.$t('public.approval') + this.$t('class.success'),
            })
          }
        })
      }
    },
    //拒绝审批
    approveReject(approveData) {
      return () => {
        this.$http(this.$api.APPROVALREJECT, approveData).then((r) => {
          if (r.code == 0) {
            this.selectedRowKeys = []
            this.$emit('read')
            this.approvalData()
            this.$notification.open({
              type: 'success',
              message: this.$t('public.approval'),
              description:
                this.$t('public.approval') + this.$t('class.success'),
            })
          }
        })
      }
    },
    operationTips(title, content, callBack) {
      this.$confirm({
        title: title,
        content: content,
        onOk() {
          callBack()
        },
      })
    },
    // 默认学年学期
    selectYearSemester() {
      const nowTime = new Date()
      const year = nowTime.getFullYear()
      const month = nowTime.getMonth() + 1

      if (month > 8) {
        for (const item of this.academicYearList) {
          if (item.indexOf(year) === 0) {
            this.academic = item
          }
        }
      } else {
        for (const item of this.academicYearList) {
          if (item.indexOf(year - 1) === 0) {
            this.academic = item
          }
        }
      }
    },
  },
  created() {
    // this.selectYearSemester()
    this.approvalData()
  },
  computed: {
    ...mapGetters(['academicYearList', 'userId']),
  },
}
</script>
